module.exports = __webpack_public_path__ + "static/media/flakes.e9ccc932.png";